
/* SHIPPING_ZONE */
export const GET_SHIPPING_ZONE_LISTING = "GET_SHIPPING_ZONE_LISTING";
export const GET_SHIPPING_ZONE_LISTING_SUCCESS = "GET_SHIPPING_ZONE_LISTING_SUCCESS";
export const GET_SHIPPING_ZONE_LISTING_FAIL = "GET_SHIPPING_ZONE_LISTING_FAIL";

export const GET_SHIPPING_ZONE_DETAILS = "GET_SHIPPING_ZONE_DETAILS";
export const GET_SHIPPING_ZONE_DETAILS_SUCCESS = "GET_SHIPPING_ZONE_DETAILS_SUCCESS";
export const GET_SHIPPING_ZONE_DETAILS_FAIL = "GET_SHIPPING_ZONE_DETAILS_FAIL";

export const ADD_SHIPPING_ZONE = "ADD_SHIPPING_ZONE";
export const ADD_SHIPPING_ZONE_SUCCESS = "ADD_SHIPPING_ZONE_SUCCESS";
export const ADD_SHIPPING_ZONE_FAIL = "ADD_SHIPPING_ZONE_FAIL";

export const UPDATE_SHIPPING_ZONE = "UPDATE_SHIPPING_ZONE";
export const UPDATE_SHIPPING_ZONE_SUCCESS = "UPDATE_SHIPPING_ZONE_SUCCESS";
export const UPDATE_SHIPPING_ZONE_FAIL = "UPDATE_SHIPPING_ZONE_FAIL";

export const UPDATE_SHIPPING_ZONE_ACTIVATION = "UPDATE_SHIPPING_ZONE_ACTIVATION";
export const UPDATE_SHIPPING_ZONE_ACTIVATION_SUCCESS = "UPDATE_SHIPPING_ZONE_ACTIVATION_SUCCESS";
export const UPDATE_SHIPPING_ZONE_ACTIVATION_FAIL = "UPDATE_SHIPPING_ZONE_ACTIVATION_FAIL";

export const DELETE_SHIPPING_ZONE = "DELETE_SHIPPING_ZONE";
export const DELETE_SHIPPING_ZONE_SUCCESS = "DELETE_SHIPPING_ZONE_SUCCESS";
export const DELETE_SHIPPING_ZONE_FAIL = "DELETE_SHIPPING_ZONE_FAIL";

export const EXPORT_SHIPPING_ZONE = "EXPORT_SHIPPING_ZONE";
export const EXPORT_SHIPPING_ZONE_SUCCESS = "EXPORT_SHIPPING_ZONE_SUCCESS";
export const EXPORT_SHIPPING_ZONE_FAIL = "EXPORT_SHIPPING_ZONE_FAIL";

export const RESET_SHIPPING_ZONE_STATE = 'RESET_SHIPPING_ZONE_STATE';
export const RESET_SHIPPING_ZONE_ACTION_STATE = 'RESET_SHIPPING_ZONE_ACTION_STATE';